/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'createCustomerRunnerTicketConversionBySystemGameId',
    message: messages.SUCCESS_CREATE_CUSTOMER_RUNNER_TICKET_CONVERSION_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/customer/:customerId/runner-ticket-conversion/:systemGameId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_CUSTOMER_RUNNER_TICKET_CONVERSION,
    requestSchema: requestSchemas.customerRunnerTicketConversions.createCustomerRunnerTicketConversionBySystemGameId,
  },
  {
    action: 'deleteCustomerRunnerTicketConversionsBySystemGameId',
    message: messages.SUCCESS_DELETE_CUSTOMER_RUNNER_TICKET_CONVERSIONS_BY_SYSTEM_GAME_ID,
    method: 'DELETE',
    path: '/customer/:customerId/runner-ticket-conversions/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_RUNNER_TICKET_CONVERSION,
    requestSchema: requestSchemas.customerRunnerTicketConversions.deleteCustomerRunnerTicketConversionsBySystemGameId,
  },
  {
    action: 'getCustomerRunnerTicketConversionsBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_RUNNER_TICKET_CONVERSIONS_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/runner-ticket-conversions/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_RUNNER_TICKET_CONVERSION,
    requestSchema: requestSchemas.customerRunnerTicketConversions.getCustomerRunnerTicketConversionsBySystemGameId,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'updateCustomerRunnerTicketConversionById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_TICKET_CONVERSION_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-conversion/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_TICKET_CONVERSION,
    requestSchema: requestSchemas.customerRunnerTicketConversions.updateCustomerRunnerTicketConversionById,
  },
];
